const isChrome = (): boolean => {
  return /(?:Chrome|CriOS)/.test(navigator.userAgent);
};

export default isChrome;
